<template>
    <div>
        <p v-if="error" class="text-danger">{{ errorMsg }}</p>
        <b-alert :show="disableSubmit" variant="danger" class="font-weight-bold text-center">
            Read Only - This version has already been submitted.
        </b-alert>
        <div v-show="formDisplayState === 'form'" key="form">
            <div id="form-placement-div"></div>
            <div class="d-flex justify-content-center align-items-center mt-3">
                <b-button 
                    form="formium-form-ajax"
                    variant="secondary"
                    size="lg"
                    @click="emitCancel"
                    class="mr-2 w-25"
                >
                    Cancel
                </b-button>
                <b-button 
                    form="formium-form-ajax"
                    type="submit"
                    variant="primary"
                    size="lg"
                    class="w-25"
                    :disabled="disableSubmit"
                    @click="handleFormSubmit($event)"
                >
                    Save
                </b-button>
            </div>
        </div>

        <div v-if="formDisplayState === 'loading'" key="loading">
            <busy-spinner text="Loading..." style="min-height: 400px;"></busy-spinner>
        </div>

        <div 
            v-if="formDisplayState === 'success'" 
            key="success" 
            class="d-flex justify-content-center align-items-center"
            style="min-height: 400px;"
        >
            <div class="text-center">
                <b-icon icon="check-circle" variant="success" font-scale="2" class="mb-3"></b-icon>
                <p class="h4 text-muted">Saved</p>
            </div>
        </div>
    </div>
</template>

<script>
// the 'hot-swap' HTML version of FormiumReply 
// don't wrap it in modal -- let parent do that
// THIS DOES NOT HANDLE CREATE FOR COMPLETELY NEW FORMIUM REPLY INSTANCES
// You should CREATE a new FormiumReply 'programmatically' first... set company, tenant, formium_form
// Then just use this for updates when you know the FormiumReply ID -- SOOOO much easier that way
// then you ONLY have one endpoint to manage -- the FormiumReplyEmbeddedUpdate  (GET from there to get form, POST to there to save data)
import { errorHandling } from '../../js/custom-vue-mixins';
import { suppliosForms } from '../../js/api-service';

export default {
    name: 'FormiumReplyHtml',
    components: {},
    mixins: [
        errorHandling,
    ],
    props: {
        replyId: {  // FormiumReply ID
            type: [String, Number],
            required: true,
        },
        disableSubmit: {  // use this to manually disable submit -- have to do it this way since we never actually fetch the full form or form reply objects
            type: Boolean,
            default: false,
        }
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            // THINGS FOR ACTIVE FORM -- set these when you get form and activate modal, reset when modal hidden
            formMode: '',  // 'create' or 'update' - used to load form from different django views (Update or Create)
            formElement: null,  // you'll find the form element and put it here so you can make new FormData 
            activePk: null,  // PK for whatever is active in form, as needed in URL for get/post calls (different depending on create/update) -- need this one attr so that all methods are re-usable
            formDisplayState: 'loading',  // used to control showing form vs. loading vs. success message 'form', 'loading', 'success'            
        }
    },
    computed: {

    },
    mounted: function() {
        this.loadQuestionList();
    },
    methods: {
        // METHODS FOR WORKING WITH PARENT <--> COMPONENT
        resetForm: function() {  // call this resetForm() ?
            // put things here to do every time modal closes... like reset inputs, reset data
            console.log('hello from resetForm');
            this.formMode = '';
            this.formElement = null;  // you'll find the form element and put it here so you can make new FormData 
            this.activePk = null;  // the active FormiumReply (used for Update)
            this.formDisplayState = 'loading';  // used to
        },
        emitCancel: function() {
            // tell parent to cancel / close this
            this.$emit('cancel');
        },
        emitSaved: function() {
            // tell parent we just saved a response 
            this.$emit('saved');  // pass up anything else?
        },
        /////////////// INTERNAL METHODS /////////////////////

        // use apiErrorHandler from mixin
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = message;
            this.error = true;
        },
        startQuestionList: function(mode, id) { // handles click on 'update' button for a questions list response already started
            if (mode === 'update') {
                this.formMode = 'update';
                this.activePk = id;  // ID for create is different than ID for update!!!
                this.loadQuestionList('update', id);
            } else if (mode === 'create') {
                this.formMode = 'create';
                this.activePk = id;  // ID for create is different than ID for update!!!
                this.loadQuestionList('create', id);
            } else {
                this.handleError('custom MH error', 'startQuestionList was passed something other than create or update');   
            }
        },
        setFormInDom: function(htmlString) {
            // takes a string of HTML (from API call to fetch form), creates DOM nodes, and appends to DOM element
            let frag = document.createRange().createContextualFragment(htmlString);
            let placementNode = document.getElementById('form-placement-div');  // this element is in modal, so modal must be shown when calling this
            // now remove any existing child nodes on parent... like the old form
            while (placementNode.firstChild) {
                placementNode.removeChild(placementNode.firstChild);
            }
            console.log('from setFormInDom, frag then placementNode');
            console.log(frag);
            console.log(placementNode);
            placementNode.appendChild(frag);  // add our new form
        },
        loadQuestionList: function() {  // gets form from backend & places in DOM
            this.formDisplayState = 'loading';
            suppliosForms.formiumReply.update.get(this.replyId)  // get the form HTML
            .then(response => {
                this.formDisplayState = 'form';
                //this.modalShowing = true;  // show modal here so you can append form to element inside it
                console.log('response from loadQuestionList, should be text');
                console.log(response);
                this.$nextTick(function() {  // waiting til nextTick to append form to DOM so modal is fully loaded
                    const responseFormString = response.data;  // should be a string of form HTML
                    if (typeof responseFormString === 'string') {
                        this.setFormInDom(responseFormString);  // NEW - call our method to actually place in DOM
                    } else {
                        this.handleError('problem', 'Unrecognized server response when getting form.');
                    }
                })
            })
            .catch(error => {
                this.handleError(error, 'Error while getting form');
            })
            .then(() => {
                // show modal, then find the actual HTML <form> element and set this.formElement
                this.$nextTick(function() {
                    this.formElement = document.getElementById("formium-form-ajax");
                    console.log('logging this.formElement from loadQuestionList final then');
                    console.log(this.formElement);
                })
            })
        },
        handleFormSubmit: function(event) {
            // need to distinguish between update and create... use this.formMode for that
            if (this.disableSubmit) { // we disable the button, and here
                return;
            }
            this.formDisplayState = 'loading';
            console.log('logging event from handleFormSubmit');
            console.log(event);
            const formDataObj = new FormData( this.formElement );
            console.log('logging formDataObj from handleFormSubmit, but maybe cannot read due to browswer security');
            console.log(formDataObj);
            if (event) {  // can't put this on the form submit because that is not Vue template
                event.preventDefault();
            }
            // we also must send rfx_response PK (vendor response.... not form response)
            // will send that as query param in URL
            // can't put it in form data since django modelform is not expecting it
            // not putting it in URL conf because UpdateView does not need it, only CreateView
            // doing it this way means it will get sent for both UpdateView and CreateView, but on backend we'll ignore it on UpdateView
            /* const axiosConfig = {
                params: {
                    vendor_response: this.responsePk,
                },
            }; */
            //const crudMode = this.formMode;  // will be 'create' or 'update'
            suppliosForms.formiumReply.update.post(this.replyId, formDataObj)
            .then(response => {
                console.log('logging response + response.headers (content-type) from handleFormSubmit');
                console.log(response);
                console.log(response.headers['content-type']);
                // const isRespStatusOk = response.status < 400;
                // const isJsonResponse = response.headers['content-type'].includes('json');
                // const responseDataType = typeof response.data; // for some reason, this is coming in as a string, not JSON object -- we should also fix that in backend!
                // // you don't actually need any of this 'wonderful' stuff.... if you get a JSON response back, then you know form was valid and you can just show success message
                // // I think its the Axios instance I'm using that is not automatically parsing the JSON response, even though it is coming back with content-type application/json -- so you have to check content-type and then parse it yourself if you want to check the actual data in the response
                // const isWonderfulReplyStatus = isJsonResponse && response.data.reply_status === 'wonderful';
                // console.log(`isRespStatusOk: ${isRespStatusOk}, isJsonResponse: ${isJsonResponse}, isWonderfulReplyStatus: ${isWonderfulReplyStatus}, responseDataType: ${responseDataType}`);
                if (response.status < 400 && response.headers['content-type'].includes('json')) {
                    // if form is valid on server side, it will send back JSON response with reply_status: 'wonderful' and reply_pk: this formium reply PK created/updated
                    // if here, then POST was ok and form_valid on backend side
                    this.handleFormSuccess();
                } else if (response.headers['content-type'].includes('text') && typeof response.data === 'string') {
                    // checking content-type of response... since form_valid sends back JSON and form_invalid sends back HTML form
                    // if this is true, then we didn't get JSON response, so we should take the response.data and set it as our form HTML content
                    //this.modalShowing = true;  // should already be showing, but just in case
                    this.formDisplayState = 'form';
                    this.setFormInDom(response.data);  // NEW way of putting form in DOM
                    this.$nextTick(function() {  // and get new formElement to create FormData
                        this.formElement = document.getElementById("formium-form-ajax");
                        console.log('got form returned to us, updated it and got new formElement below');
                        console.log(this.formElement);
                    });
                } else {
                    // if here, then something strange happened, not sure what
                    //this.modalShowing = false;
                    this.emitCancel();
                    this.$toast.error('There was an error saving your responses.  Please contact Support.');
                    //this.handleError('unknown error', 'Unknown server response after posting form');
                }
            })
            .catch(error => {
                this.handleError(error, 'Error during post in handleFormSubmit');
                //this.modalShowing = false;
                this.emitCancel();
            })
        },
        handleFormSuccess: function() { // we call this once we know form was submitted OK
            this.formDisplayState = 'success';
            setTimeout(() => {
                //this.modalShowing = false;  // this will automatically call onModalHidden also
                this.emitSaved();
                // SKIP THIS - ALREADY HAVE SAVE MESSAGE this.$toast.success('Your responses have been saved.');
                //this.getResponseForms(true);  // reload lists to reflect changes and skipLoading = true
            }, 2500);
        },

    }
}
</script>

<style>

</style>